package com.flowyride.core.domain.routing

import com.flowyride.core.domain.analysis.distanceTo
import com.flowyride.core.domain.model.GeoPoint

object WaypointInsertion {

    /**
     * Where to insert [point] in [waypoints] (departure … arrival) so that the detour is the smallest:
     * the rider adds a stop "on the way", not necessarily just before the arrival.
     *
     * Straight-line approximation: good enough to pick a leg, no routing call needed.
     *
     * @return an index in `1..waypoints.size - 1` (never before the departure nor after the arrival).
     */
    fun bestIndex(waypoints: List<GeoPoint>, point: GeoPoint): Int {
        require(waypoints.size >= 2) { "Need at least a departure and an arrival" }
        return (1..waypoints.lastIndex).minBy { index ->
            val before = waypoints[index - 1]
            val after = waypoints[index]
            before.distanceTo(point) + point.distanceTo(after) - before.distanceTo(after)
        }
    }
}
